import { NavMenu as HudskitNavMenu } from 'hfs-common-ui';
import { useUptimeNavigation } from 'core/hooks/use-uptime-navigation';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { useMemo } from 'react';
import useMediaQuery from 'core/hooks/use-media-query';
import { device } from 'core/styles/variables';
import { useDealersReportConfig } from 'feature/dealers/hooks/use-dealers-report-config';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { getUptimeMenu } from './menu';

const NavMenu = () => {
  const isRemoteConfigReady = useRemoteConfig();
  const isDesktop = useMediaQuery(device.lg);

  const { isDealersReportEnabled } = useDealersReportConfig();
  const { user } = useAppSelector((state) => state.auth);
  const dealersReportEnabled = useMemo<boolean>(() => isDealersReportEnabled(user?.id), [isDealersReportEnabled, user?.id]);

  const navMenu = useMemo(
    () => getUptimeMenu(isDesktop, dealersReportEnabled).menu,
    [dealersReportEnabled, isDesktop]
  );
  const { activeMenuId, onClickHandler } = useUptimeNavigation(navMenu);
  return isRemoteConfigReady && <HudskitNavMenu menu={navMenu} onClick={onClickHandler} activeMenuItemId={activeMenuId} />;
};
export default NavMenu;
